import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

const LetterForm = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    gpName: '',
    letterDate: '',
    toAddress: '<b>मा. गटविकास अधिकारी,</b><br>पंचायत समिती,',
    subject: '',
    reference: '',
    mainContent: '<b>मा. महोदय,</b><br> वरील विषयी सविनय सादर करण्यात येते कि,',
    attached: '',
    copyTo: ''
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handlePrint = () => {
    window.print();
  };

  return (
    <div className="min-h-screen bg-[#f4f6f9] py-5 px-2 font-sans">
      <style>
        {`
          @media print {
            @page {
              size: A4;
              margin: 10mm;
            }
            body {
              visibility: hidden;
              background: white !important;
            }
            #printable-area {
              visibility: visible;
              position: absolute;
              left: 0;
              top: 0;
              width: 100%;
              padding: 15mm;
              display: block !important;
              color: black !important;
            }
            .no-print {
              display: none !important;
            }
          }
        `}
      </style>

      {/* Main Form */}
      <div className="w-full bg-white border border-gray-300 shadow-sm rounded-sm overflow-x-auto no-print">
        <div className="bg-[#fff9e6] py-2 px-4 border-b border-gray-300 min-w-[1000px] flex justify-between items-center gap-2">
          <h2 className="text-[#b71c1c] text-left shrink text-[14px] sm:text-[17px] font-bold flex items-center  gap-2">
            <span className="text-blue-600 text-xl leading-none">✹</span> पत्र तयार करा
          </h2>
          <button onClick={() => navigate(-1)} className="bg-gray-200 hover:bg-gray-300 text-gray-800 font-bold py-1 px-4 rounded text-sm no-print whitespace-nowrap shrink-0">
              मागे जा
            </button>
        </div>

        <div className="p-6 min-w-[1000px]">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-x-12 gap-y-6">
            
            <div className="flex flex-col gap-1">
              <label className="text-[13px] font-bold text-[#333]">ग्रामपंचायतीचे नाव</label>
              <select name="gpName" value={formData.gpName} onChange={handleChange} className="border border-[#ccc] rounded-sm px-2 py-1.5 text-sm bg-white outline-none focus:border-blue-400">
                <option value="">ग्रामपंचायत निवडा</option>
                <option value="धामणी">धामणी</option>
              </select>
            </div>
            <div className="flex flex-col gap-1">
              <label className="text-[13px] font-bold text-[#333]">पत्राचा दिनांक</label>
              <input type="date" name="letterDate" value={formData.letterDate} onChange={handleChange} className="border border-[#ccc] rounded-sm px-2 py-1.5 text-sm outline-none focus:border-blue-400" />
            </div>

            <div className="md:col-span-1 flex flex-col gap-1">
              <label className="text-[13px] font-bold text-[#333]">प्रति</label>
            </div>
            <div className="md:col-span-1 flex flex-col gap-1">
              <textarea 
                name="toAddress" 
                value={formData.toAddress} 
                onChange={handleChange} 
                className="border border-[#ccc] rounded-sm px-3 py-2 text-sm outline-none focus:border-blue-400 h-20 resize-none"
              ></textarea>
            </div>

            <div className="md:col-span-1 flex flex-col gap-1">
              <label className="text-[13px] font-bold text-[#333]">विषय</label>
            </div>
            <div className="md:col-span-1 flex flex-col gap-1">
              <input type="text" name="subject" value={formData.subject} onChange={handleChange} className="border border-[#ccc] rounded-sm px-2 py-1.5 text-sm outline-none focus:border-blue-400" />
            </div>

            <div className="md:col-span-1 flex flex-col gap-1">
              <label className="text-[13px] font-bold text-[#333]">संदर्भ</label>
            </div>
            <div className="md:col-span-1 flex flex-col gap-1">
              <input type="text" name="reference" value={formData.reference} onChange={handleChange} className="border border-[#ccc] rounded-sm px-2 py-1.5 text-sm outline-none focus:border-blue-400" />
            </div>

            <div className="md:col-span-1 flex flex-col gap-1">
              <label className="text-[13px] font-bold text-[#333]">पत्राचा मुख्य भाग</label>
            </div>
            <div className="md:col-span-1 flex flex-col gap-1">
              <textarea 
                name="mainContent" 
                value={formData.mainContent} 
                onChange={handleChange} 
                className="border border-[#ccc] rounded-sm px-3 py-2 text-sm outline-none focus:border-blue-400 h-24 resize-none"
              ></textarea>
            </div>

            <div className="md:col-span-1 flex flex-col gap-1">
              <label className="text-[13px] font-bold text-[#333]">सोबत (attached)</label>
            </div>
            <div className="md:col-span-1 flex flex-col gap-1">
              <textarea 
                name="attached" 
                value={formData.attached} 
                onChange={handleChange} 
                className="border border-[#ccc] rounded-sm px-3 py-2 text-sm outline-none focus:border-blue-400 h-16 resize-none"
              ></textarea>
            </div>

            <div className="md:col-span-1 flex flex-col gap-1">
              <label className="text-[13px] font-bold text-[#333]">प्रतिलिपी</label>
            </div>
            <div className="md:col-span-1 flex flex-col gap-1">
              <textarea 
                name="copyTo" 
                value={formData.copyTo} 
                onChange={handleChange} 
                className="border border-[#ccc] rounded-sm px-3 py-2 text-sm outline-none focus:border-blue-400 h-16 resize-none"
              ></textarea>
            </div>

          </div>

          <div className="mt-10 flex gap-4 justify-center">
            <button onClick={handlePrint} className="bg-[#00a65a] text-white px-20 py-1.5 rounded-sm text-sm font-semibold shadow-sm hover:bg-[#008d4c]">Save</button>
            <button className="bg-[#f39c12] text-white px-10 py-1.5 rounded-sm text-sm font-semibold shadow-sm hover:bg-[#e08e0b]">Generate Document</button>
          </div>

          <div className="mt-8 border border-gray-300 rounded-sm min-h-[400px] bg-white"></div>

          <div className="mt-4">
            <button className="bg-[#f4f4f4] border border-[#ddd] text-[#444] px-5 py-1.5 rounded-sm text-xs flex items-center gap-2 hover:bg-[#e8e8e8]">
              <span>🖨️</span> Print
            </button>
          </div>
        </div>
      </div>

      {/* Printable Letter Area */}
      <div id="printable-area" className="hidden print:block font-serif text-black bg-white">
        <div className="text-center mb-10">
          <h1 className="text-[24px] font-bold">ग्रामपंचायत कार्यालय: {formData.gpName}</h1>
          <p className="text-[16px] font-bold mt-1">ता. {formData.taluka || '---'} जि. {formData.district || '---'}</p>
        </div>

        <div className="flex justify-between mb-8">
          <div>जा.क्र./ग्रा.पं./पत्र/२०२५-२६/</div>
          <div>दिनांक: {formData.letterDate}</div>
        </div>

        <div className="mb-8 leading-relaxed" dangerouslySetInnerHTML={{ __html: formData.toAddress }}></div>

        <div className="mb-6 font-bold">
          <p>विषय: {formData.subject}</p>
          {formData.reference && <p>संदर्भ: {formData.reference}</p>}
        </div>

        <div className="mb-10 leading-loose text-justify" dangerouslySetInnerHTML={{ __html: formData.mainContent }}></div>

        {formData.attached && (
          <div className="mb-8">
            <p className="font-bold underline mb-1">सोबत:</p>
            <div dangerouslySetInnerHTML={{ __html: formData.attached }}></div>
          </div>
        )}

        {formData.copyTo && (
          <div className="mb-8 text-[14px]">
            <p className="font-bold underline mb-1">प्रतिलिपी माहितीस्तव सप्रेम सादर:</p>
            <div dangerouslySetInnerHTML={{ __html: formData.copyTo }}></div>
          </div>
        )}

        <div className="flex justify-between items-end mt-20 pr-10 pl-10 font-bold text-center">
          <div></div>
          <div>
            <p>ग्रामसेवक /ग्रामविकास अधिकारी</p>
            <p>ग्रामपंचायत {formData.gpName}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LetterForm;
